import React, { Component, useState  } from "react";
import SisModal from "store/sis/sisModal";
import { connect } from "react-redux";
import * as layoutActions from "store/modules/rds_layout";
import { bindActionCreators } from "redux";
import $ from "jquery";

import stl from "./SurveyModal.module.scss";

class SurveyModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkedList: [],
      etcEnabled: false,
      etcValue: ""
    };
  }
  
  componentDidMount() {
    const { LayoutActions } = this.props;
    LayoutActions.setModal({ id: "surveyModal", target: this });

    setTimeout(() => {
      // 오늘 날짜 객체 생성
      const today = new Date();

      // 기간 설정 (월은 0부터 시작하므로 5가 6월)
      const start = new Date(2025, 11, 24);   // 2025-12-24
      const end = new Date(2025, 11, 30, 23, 59, 59, 999); // 2025-12-31 23:59:59

      // ① 기간이 아니면 무조건 숨김
      if (today < start || today > end) {
        const el = document.getElementById("surveyModal");
        if (el) el.style.visibility = "hidden";
        return; // 더 이상 실행하지 않음
      }

      // ② 기간 내에서는 원래 로직 수행
      const hideUntil = localStorage.getItem("surveyHideUntil");
      const now = new Date().getTime();

      const el = document.getElementById("surveyModal");
      if (hideUntil && parseInt(hideUntil) > now) {
        if (el) el.style.visibility = "hidden";
      } else {
        if (el) el.style.visibility = "visible";
      }
    }, 100);
  }

  show = () => {
    this.modal.show();
  };

  hide = () => {
	  $("#surveyModal").hide();
  }

  finish = () =>{

    let sexChecked = $('input[name="sex"]').is(':checked');
    if(!sexChecked){
      alert("응답자 기본정보의 성별을 선택해주세요.");
      return;
    }
    let ageChecked = $('input[name="age"]').is(':checked');
    if(!ageChecked){
      alert("응답자 기본정보의 연령대 선택해주세요.");
      return;
    }

    let su1Checked = $('input[name="survey_1"]').is(':checked');
    if(!su1Checked){
      alert("1번 항목을 선택해주세요.");
      return;
    }

    let su2Checked = $('input[name="survey_2"]').is(':checked');
    if(!su2Checked){
      alert("2번 항목을 선택해주세요.");
      return;
    }

    let su3Checked = $('input[name="survey_3"]').is(':checked');
    if(!su3Checked){
      alert("3번 항목을 선택해주세요.");
      return;
    }

    let su4Checked = $('input[name="survey_4"]').is(':checked');
    if(!su4Checked){
      alert("4번 항목을 선택해주세요.");
      return;
    }

    let su5Checked = $('input[name="survey_5"]').is(':checked');
    if(!su5Checked){
      alert("5번 항목을 선택해주세요.");
      return;
    }

    let su6Checked = $('input[name="survey_6"]').is(':checked');
    if(!su6Checked){
      alert("6번 항목을 선택해주세요.");
      return;
    }

    let su7Checked = $('input[name="survey_7"]').is(':checked');
    if(!su7Checked){
      alert("7번 항목을 선택해주세요.");
      return;
    }

    let su8Checked = $('input[name="survey_8"]').is(':checked');
    if(!su8Checked){
      alert("8번 항목을 선택해주세요.");
      return;
    }

    let su9Checked = $('input[name="survey_9"]').is(':checked');
    if(!su9Checked){
      alert("9번 항목을 선택해주세요.");
      return;
    }

    let su10Checked = ($('#survey_10').val() || '').trim();
    if(su10Checked===""){
      alert("10번 항목을 입력해주세요.");
      return;
    }
    let sex = $('input[name=sex]:checked').val();
    let age = $('input[name=age]:checked').val();
    let survey_1 = $('input[name=survey_1]:checked').map(function() { return $(this).val(); }).get();
    survey_1 = survey_1.join(", ");
    const isChecked = $('input[name="survey_1"][value="5"]').is(':checked');
    if (isChecked) {
      survey_1 = survey_1 + ", " + document.querySelector('input[name="survey_1_etc"]').value;
    }
    let survey_2 = $('input[name=survey_2]:checked').map(function() { return $(this).val(); }).get();
    survey_2 = survey_2.join(", ");

    let survey_3 = $('input[name=survey_3]:checked').map(function() { return $(this).val(); }).get();
    survey_3 = survey_3.join(", ");

    let survey_4 = $('input[name=survey_4]:checked').map(function() { return $(this).val(); }).get();
    survey_4 = survey_4.join(", ");
    let survey_5 = $('input[name=survey_5]:checked').map(function() { return $(this).val(); }).get();
    survey_5 = survey_5.join(", ");
    let survey_6 = $('input[name=survey_6]:checked').map(function() { return $(this).val(); }).get();
    survey_6 = survey_6.join(", ");
    let survey_7 = $('input[name=survey_7]:checked').map(function() { return $(this).val(); }).get();
    survey_7 = survey_7.join(", ");
    let survey_8 = $('input[name=survey_8]:checked').map(function() { return $(this).val(); }).get();
    survey_8 = survey_8.join(", ");
    let survey_9 = $('input[name=survey_9]:checked').map(function() { return $(this).val(); }).get();
    survey_9 = survey_9.join(", ");
    
    let survey_10 = document.getElementById("survey_10").value;

    console.log(sex, age, survey_1, survey_2, survey_3, survey_4, survey_5, survey_6, survey_7, survey_8, survey_9 , survey_10);

    $.ajax({
			url: "/api/setSurvey",
      type: "post",
			data: { sex, age, survey_1, survey_2, survey_3, survey_4, survey_5, survey_6, survey_7, survey_8, survey_9 , survey_10 },
			success: (res) => {
				if(res >= 0){
          alert("설문조사에 참여해주셔서 감사합니다.");
          this.hide();
        }		
			},
		});
  }

  handleCheckbox = (e) => {
    const { value, checked } = e.target;
    let newCheckedList = [...this.state.checkedList];
    if (checked) {
      newCheckedList.push(value);
    } else {
      newCheckedList = newCheckedList.filter(v => v !== value);
    }
    this.setState({
      checkedList: newCheckedList,
      etcEnabled: newCheckedList.includes("5")
    });
  };

  handleEtcChange = (e) => {
    this.setState({ etcValue: e.target.value });
  };
  render() {
    // 동그라미 숫자 배열 생성
    const circledNumbers = ["①", "②", "③", "④", "⑤"];
    const surveyScale = [
      "매우 그렇다",
      "그렇다",
      "보통이다",
      "그렇지 않다",
      "매우 그렇지 않다"
    ];
    const contents = (
      <div className={stl.popWindow_survey}>
        <div className={stl.modal_main}>
        	<div className={stl.survey_content}>
            본 조사는 <h4>스마트도시분석포털</h4>을 이용하시면서 귀하께서 느끼는 만족도를 알아보기 위한 것입니다.<br />
            귀하께서 답변해주신 내용은 <h4>스마트도시분석포털 기능 개선</h4> 등에 활용될 예정이오니<br />
            바쁘시더라도 정성껏 답변해주시면 감사하겠습니다.
        	</div>
        	<div className={`${stl.survey_div} ${stl.sexAge_div}`}>
				    <span>( 응답자 기본정보 )</span>
				    <div className={stl.inlineRow}>
					    - 성&nbsp;&nbsp;&nbsp;별
              <label><input type="radio" name="sex" value="남성" /> 남성</label>
              <label><input type="radio" name="sex" value="여성" /> 여성</label>
				    </div>
            <div className={stl.inlineRow}>
              - 연령대
              <label><input type="radio" name="age" value="10대" /> 10대</label>
              <label><input type="radio" name="age" value="20대" /> 20대</label>
              <label><input type="radio" name="age" value="30대" /> 30대</label>
              <label><input type="radio" name="age" value="40대" /> 40대</label>
              <label><input type="radio" name="age" value="50대" /> 50대</label>
              <label><input type="radio" name="age" value="60대" /> 60대</label>
              <label><input type="radio" name="age" value="70대이상" /> 70대이상</label>
            </div>
			    </div>

          {[...Array(10)].map((_, i) => (
            <div className={stl.survey_div} key={i} style={{ marginTop: "20px" }}>
              <span>
                {`${i + 1}. `}
                {["스마트도시분석포털을 어떻게 알게 되셨나요? (2개 이하 중복응답 가능)",
                  "스마트도시분석포털을 얼마나 자주 이용하십니까?",
                  "스마트도시분석포털을 이용하는 주된 목적은 무엇입니까? (2개 이하 중복응답 가능)",
                  "가장 자주 이용하는 메뉴는 무엇인가요?",
                  "스마트도시분석포털 시스템의 메뉴가 명확하게 구분되어 있습니까?",
                  "스마트도시분석포털 시스템의 디자인 구성요소(아이콘, 색상 등)이 적절히 배치 되어있습니까?",
                  "스마트도시분석포털 시스템의 응답 속도가 적정한가요?",
                  "스마트도시분석포털의 개선이 필요한 부분은 무엇이라고 생각하십니까? (2개 이하 중복응답 가능)",
                  "추가ㆍ확대가 필요한 서비스 분야는 무엇이라고 생각하십니까? (3개 이하 중복응답 가능)",
                  "추가가 필요한 정보 등 서비스 개선에 대한 의견을 자유롭게 적어주시기 바랍니다."]
                [i]}
              </span>
              <br />
              {i === 0 && (
                <>
                  <label>
                    <input type="checkbox" name="survey_1" value="1" onChange={this.handleCheckbox}/>① 지인추천
                  </label><br/>
                  <label>
                    <input type="checkbox" name="survey_1" value="2" onChange={this.handleCheckbox}/>② 인터넷 검색
                  </label><br/>
                  <label>
                    <input type="checkbox" name="survey_1" value="3" onChange={this.handleCheckbox}/>③ 뉴스 및 신문기사
                  </label><br/>
                  <label>
                    <input type="checkbox" name="survey_1" value="4" onChange={this.handleCheckbox}/>④ 타 홈페이지
                  </label><br/>
                  <label>
                    <input type="checkbox" name="survey_1" value="5" onChange={this.handleCheckbox}/>⑤ 기타
                  </label>
                  <label>
                    <input
                      type="text"
                      name="survey_1_etc"
                      value={this.state.etcValue}
                      disabled={!this.state.etcEnabled}
                      onChange={this.handleEtcChange}
                      style={{ border: "solid 1px", marginLeft: "5px", width: "200px" }}
                    />
                  </label>
                </>
              )}
              {i === 1 && [
                "① 수시로 이용",
                "② 한 달에 1회",
                "③ 한 달에 2~3회",
                "④ 분기에 1회",
                "⑤ 거의 이용하지 않는다"
              ].map((label, idx) => (
                <label key={idx}><input type="radio" name="survey_2" value={idx + 1} />{label}</label>
              ))}
              {i === 2 && [
                "① 연구분석(논문)",
                "② 정책수립의 기초자료",
                "③ 교육용 자료",
                "④ 단순 정보 파악",
                "⑤ 기타"
              ].map((label, idx) => (
                <label key={idx}><input type="checkbox" name="survey_3" value={idx + 1} />{label}</label>
              ))}
              {i === 3 && [
                "① 지도서비스",
                "② 분야별지도",
                "③ 통계연보",
                "④ 기타"
              ].map((label, idx) => (
                <label key={idx}><input type="radio" name="survey_4" value={idx + 1} />{label}</label>
              ))}
              {i === 4 && [1, 2, 3, 4, 5].map((v,idx) => (
                <label key={v}><input type="radio" name="survey_5" value={v} />{circledNumbers[idx]}{surveyScale[idx]}</label>
              ))}
              {i === 5 && [1, 2, 3, 4, 5].map((v,idx) => (
                <label key={v}><input type="radio" name="survey_6" value={v} />{circledNumbers[idx]}{surveyScale[idx]}</label>
              ))}
              {i === 6 && [1, 2, 3, 4, 5].map((v,idx) => (
                <label key={v}><input type="radio" name="survey_7" value={v} />{circledNumbers[idx]}{surveyScale[idx]}</label>
              ))}
              {i === 7 && [
                "① 다양한 분야의 정보 추가",
                "② 상ㆍ하위 메뉴 구성 체계화",
                "③ 디자인 및 시각화 기능 강화",
                "④ 정보 업데이트 주기 단축",
                "⑤ 기타"
              ].map((label, idx) => (
                <label key={idx}><input type="checkbox" name="survey_8" value={idx + 1} />{label}</label>
              ))}
              {i === 8 && [
                "교통", "도시ㆍ건설", "산업ㆍ경제", "복지ㆍ건강", "재난ㆍ안전",
                "행정ㆍ재세정", "환경", "문화ㆍ체육", "관광", "기타"
              ].map((label, idx) => (
                <label key={idx}><input type="checkbox" name="survey_9" value={idx + 1} />{label}</label>
              ))}
              <label htmlFor="survey_10">설문조사</label>
              {i === 9 && (
                <textarea
                  id="survey_10"
                  rows="4"
                  cols="60"
                  className={stl.survey_10}
                  placeholder="예시) 000 시설 현황 정보 추가, 000통계정보를 월단위로 확인할 수 있도록 개선"
                ></textarea>
              )}
            </div>
          ))}

			<div className={stl.div_survey_finish}>
        <label htmlFor="surveyBtn">설문제출</label>
				<input id="surveyBtn" type="button" className={stl.survey_finish} onClick={() => this.finish()} value="설문제출" />
			</div>
        </div>

        <div className={stl.close}>
    		  <div className={stl.check}>
            <label>
              <input
                type="checkbox"
                name="chkbox"
                title="오늘 하루동안 보지 않기"
                onChange={(e) => {
                if (e.target.checked) {
                  const now = new Date();
                  const expire = now.getTime() + 24 * 60 * 60 * 1000; // 1일 후 타임스탬프
                  localStorage.setItem("surveyHideUntil", expire.toString());
                } else {
                  localStorage.removeItem("surveyHideUntil");
                }
                }}
              /></label>
              오늘 하루동안 보지 않기
          </div>
          <div className={stl.close2} style={{ marginLeft: "12px" }}><button onClick={() => this.modal.close()}>닫기</button></div>
        </div>
      </div>
    );

    return (
      <SisModal
        id={this.props.id}
        ref={(ref) => (this.modal = ref)}
        className={stl.surveyModal}
        draggable
        title="스마트도시분석포털 이용 설문조사"
        closeEvent={() => {
			this.hide();
		}}
        contents={contents}
      />
    );
  }
}

export default connect(
  (state) => ({ layout: state.layout }),
  (dispatch) => ({ LayoutActions: bindActionCreators(layoutActions, dispatch) })
)(SurveyModal);